import { Period } from '../../../common/service/occ/types';
import { EditOccFormShape } from '../EditOccValuesDrawer/EditOccValuesDrawer';
import { mapLabelToCapacityType } from '../utils/capacityTypeMapper';

export type UpdateOccDto = {
  vesselPairLimits: number;
  from: string;
  to: string;
  terminalCodeAndType: string;
  period: Period;
};

export const createOccDto = (formData: EditOccFormShape): UpdateOccDto => {
  return {
    vesselPairLimits: formData.vesselPairLimits,
    from: mapLabelToCapacityType(formData.from),
    to: mapLabelToCapacityType(formData.to),
    terminalCodeAndType: formData.terminalCode + '-' + formData.dateType,
    period: formData.period === 'CURRENT' ? Period.Current : Period.Next,
  };
};
